export const acceptedImagesFilesTypes = [
  "image/jpeg",
  "image/png",
  "image/bmp",
  "image/jpg",
  "image/gif",
  "image/svg+xml",
];

export const acceptedImagesFilesMaxSize = 5242880;

export const acceptedPdfFilesType = ["application/pdf"];

export const acceptedPdfFilesMaxSize = 5242880;

/** SA (Saudi Arabia) timezone offset in minutes. System expects +03:00 for all API datetime values. */
export const SA_UTC_OFFSET_MINUTES = 180;

/** Key into `messages[lang].shared` for the display currency label (e.g. "SAR"). */
export const CURRENCY_LOCALE_KEY = "sar";

export const lookupsKeys = {
  adminRoles: "admin_roles",
  /** Company portal GET /lookups — event categories (Party, Conference, …). */
  eventTypes: "event_types",
  requirements: "requirements",
  roles: "roles",
  languages: "languages",
  disabilities: "disabilities",
  chronicDiseases: "chronic_diseases",
  fieldOfStudies: "field_of_studies",
  banks: "banks",
  workingLogsAttributes: "working_log",
  tags: "tags",
};
export const reversedLookupsKeys = {
  admin_roles: "adminRoles",
  event_types: "eventTypes",
  requirements: "requirements",
  roles: "roles",
  languages: "languages",
  disabilities: "disabilities",
  chronic_diseases: "chronicDiseases",
  field_of_studies: "fieldOfStudies",
  banks: "banks",
  working_log: "workingLogsAttributes",
  tags: "tags",
};

export const eventStatuses = {
  ongoing: "ongoing",
  upcoming: "upcoming",
  past: "past",
  pending: "pending",
  cancelled: "canceled",
};

export const requestStatuses = {
  accepted: "approved",
  notAccepted: "pending",
  cancelled: "cancelled",
  autoCancelled: "auto_cancelled",
};
export const promotionRequestsStatus = {
  accepted: "approved",
  notAccepted: "pending",
  rejected: "rejected",
};

export const evaluationFormStatus = {
  pending: "pending",
  submitted: "submitted",
};

export const workingLogsColumns = {
  // daily events
  dailyNameAr: "user_full_name_ar",
  dailyNameEn: "user_full_name_en",
  dailyRole: "role_name",
  dailyIdentificationId: "user_identification_id",
  dailyNationality: "nationality_name",
  selfCheckoutDates: "self_checkout_dates",
  automaticCheckoutDates: "automatic_checkout_dates",
  dailyPhoneNumber: "user_phone_number",
  dailyEmail: "user_email",
  dailyDobHijri: "user_hijri_date_of_birth",
  dailyNumberOfDays: "number_of_days",
  dailyWorkingHours: "working_hours",
  dailyExpectedPayroll: "expected_payroll",
  dailyTotalExpectedPayroll: "total_expected_payroll",
  dailyIban: "user_iban",
  dailySignature: "signature",
  monthlyDate: "readable_date",
  monthlyApplicantName: "user_name",
  monthlyRole: "role_name",
  monthlyWorkingHours: "working_hours",
  monthlyExpectedTotalPayroll: "total_expected_payroll",
  stcNumber: "user_stc_number",
};

export const eventCheckinVerificationMethodsLocalization = {
  basic_verification: "basicVerification",
  supervisor_approval: "supervisorApproval",
  scanning_organizer_qr: "organizerScanning",
  scanning_supervisor_qr: "supervisorScanning",
};

export const eventCheckinVerificationMethods = {
  basicVerification: "basic_verification",
  supervisorApproval: "supervisor_approval",
  organizerScanning: "scanning_organizer_qr",
  supervisorScanning: "scanning_supervisor_qr",
};

export const applicantsProfileStatus = {
  verified: "verified",
  profileCompleted: "profile_completed",
  basicProfileCompleted: "basic_profile_completed",
};

export const genders = {
  male: "male",
  female: "female",
  notProvided: "prefer_not_to_say",
};

export const eventTypes = {
  daily: "daily",
  monthly: "monthly",
};

export const eventPublishingModes = {
  public: "public",
  private: "private",
};

export const otherRolesStatus = {
  enabled: "enabled",
  disabled: "disabled",
};

/** Company-portal permission `module_name` values (API contract — must match
 * the backend's permissions matrix; see PROLINE-2589). */
export const companyPermissionModules = {
  applicants: "Applicants",
  employees: "Employees",
  joiningEvents: "Joining Events",
  events: "Events",
  payroll: "Payroll",
  timesheet: "Timesheet",
  manageClients: "Manage Clients",
  manageReports: "Manage Reports",
  evaluations: "Evaluations",
  reports: "Reports",
  surveyScore: "Survey Score",
  heatmap: "Heatmap",
  rolesManagement: "Roles Management",
};

/** Admin-portal permission `module_name` values (API contract — matches the
 * fresh `/admin_roles/:id/permissions` matrix). */
export const adminPermissionModules = {
  employees: "Employees",
  rolesManagement: "Roles Management",
  applicants: "Applicants",
  events: "Events",
  joiningEvents: "Joining Events",
  payroll: "Payroll",
  timesheet: "Timesheet",
  evaluations: "Evaluations",
  promotions: "Promotions",
  manageReports: "Manage Reports",
  manageClients: "Manage Clients",
  reports: "Reports",
};

/** Maps the server-facing `attribute_name` strings submitted by SurveyForm to the
 * i18n keys under `clientSatisfaction.criteria`, so the stored English label can be
 * rendered localized. */
export const clientScoreAttributeKeys = {
  "Service Quality": "serviceQuality",
  "Speed Response": "speedResponse",
  Compliance: "compliance",
  "Defining Requests": "definingRequests",
  "Finance Department": "financeDepartment",
  "Price Terms": "priceTerms",
  "Complaint Resolution": "complaintResolution",
  "Complaint Way": "complaintWay",
  "Attention to Detail": "attentionToDetail",
};
